export const QUESTION_REQUEST = "QUESTION_REQUEST";
export const QUESTION_RECEIVE = "QUESTION_RECEIVE";
export const QUESTION_FAILURE = "QUESTION_FAILURE";
export const RESET_QUESTION = "RESET_QUESTION";

export const ANSWER_RESPONSE_REQUEST = "ANSWER_RESPONSE_REQUEST";
export const ANSWER_RESPONSE_RECEIVE = "ANSWER_RESPONSE_RECEIVE";
export const ANSWER_RESPONSE_FAILURE = "ANSWER_RESPONSE_FAILURE";
export const RESET_ANSWER_RESPONSE = "RESET_ANSWER_RESPONSE";
